export default __webpack_public_path__ + "static/media/pic1.4d54ccf9.jpg";